// Firms excluded from applying Redacted label
export const TEST_FIRM_IDS = [
  // Demo accounts without PII
  1,
  // Test accounts without PII
  139,
  470,
  597,
  619, // React App firm (for testing the new React app)
];
